export interface BellNotification {
  id: string
  userId: string
  platformUserId?: string
  message: string
  type: string
  payloadType: string | null
  relatedUrl: string | null
  isRead: boolean
  createdAt: string | null
}

/**
 * Known `payloadType` values produced by Brushfire services.
 * New types should be added here as new notification producers are built.
 * The `relatedUrl` field (when set) always takes routing priority over payloadType.
 */
export const NotificationPayloadType = {
  CAMPAIGN_CREATED: 'campaign_created',
  CAMPAIGN_LAUNCHED: 'campaign_launched',
  INSTRUMENT_PUBLISHED: 'instrument_published',
  TEAM_MEMBER_JOINED: 'team_member_joined',
} as const

export type NotificationPayloadType =
  (typeof NotificationPayloadType)[keyof typeof NotificationPayloadType]

/**
 * Return the navigation path for a notification.
 * Priority:
 *  1. Explicit `relatedUrl` stored on the row (backward-compatible, most specific).
 *  2. Fallback routes derived from `payloadType` (for types where no relatedUrl is set).
 *  3. `null` — notification is informational only; clicking does not navigate.
 */
export function getNotificationRoute(n: BellNotification): string | null {
  if (n.relatedUrl) return n.relatedUrl

  switch (n.payloadType) {
    case NotificationPayloadType.CAMPAIGN_CREATED:
    case NotificationPayloadType.CAMPAIGN_LAUNCHED:
      return '/campaigns'
    case NotificationPayloadType.INSTRUMENT_PUBLISHED:
      return '/instruments'
    case NotificationPayloadType.TEAM_MEMBER_JOINED:
      return null // informational only
    default:
      return null
  }
}
